/**
 * Reset password layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import RegularCard from 'Common/Cards/RegularCard.jsx';
import GridContainer from 'Common/Grid/GridContainer';
import ItemGrid from 'Common/Grid/ItemGrid';

import { pageTitleDecorator, guestPageDecorator } from 'Decorators';
import { resetPassword, checkResetPasswordToken } from 'Actions/auth';

import styles from './styles.js';
import BACKGROUND_IMAGE from 'Layouts/Layout/images/fullpage-image.jpeg';
import ResetPasswordForm from './ResetPasswordForm';
import Loader from 'Common/Loader/Loader';

@withStyles(styles)
@connect(store => ({
    loading: store.resetPassword.loading,
    success: store.resetPassword.success,
    error: store.resetPassword.error,
    isValidToken: store.resetPassword.isValidToken,
}), dispatch => ({
    resetPassword: data => dispatch(resetPassword(data)),
    checkResetPasswordToken: token => dispatch(checkResetPasswordToken(token)),
}))
@guestPageDecorator()
@pageTitleDecorator('reset')
export default class ResetPassword extends React.Component {

    /**
     * @type {Object}
     */
    static propTypes = {
        loading: PropTypes.bool,
        success: PropTypes.bool,
        error: PropTypes.bool,
        classes: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        resetPassword: PropTypes.func.isRequired,
        checkResetPasswordToken: PropTypes.func.isRequired,
        isValidToken: PropTypes.bool
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    /**
     *
     * @param data
     */
    handleResetPassword(data) {
        this.props.resetPassword({ token: this.props.match.params.token, ...data });
    }

    /**
     * Component Did Mount
     */
    componentDidMount() {
        const { checkResetPasswordToken, match: { params: { token } } } = this.props;
        checkResetPasswordToken(token);
    }

    render() {
        const { classes, isValidToken, loading } = this.props;
        if (!isValidToken || loading) {
            return <Loader />;
        }

        return (
            <div
                className={classes.wrapper}
            >
                <div className={classes.fullPage}>
                    <div className="outside-logo outside-centered-logo">
                        <a href="/">
                            <div className="outside-logo-image"></div>
                            <div className="outside-logo-text"></div>
                        </a>
                    </div>
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <ItemGrid
                                xs={12}
                                sm={6}
                                md={4}
                            >
                                <RegularCard
                                    cardTitle={this.context.intl.formatMessage({ id: 'reset.title' })}
                                    cardSubtitle={this.context.intl.formatMessage({ id: 'reset.subtitle' })}
                                    titleAlign="center"
                                    customCardTitleClasses={classes.cardTitle}
                                    customCardClasses={classes.cardClasses}
                                    content={
                                        <ResetPasswordForm onSubmit={this.handleResetPassword.bind(this)} />
                                    }
                                />
                            </ItemGrid>
                        </GridContainer>
                    </div>
                </div>
                <div
                    className={classes.fullPageBackground}
                    style={{ backgroundImage: 'url(' + BACKGROUND_IMAGE + ')' }}
                />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/layouts/ResetPassword/ResetPassword.jsx